import {
  useAccessToken,
  useAuthActions,
  useRefreshToken,
} from '@core-frontend/core-frontend';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { loadTokensFromCookies } from '@/entities/session/lib';

const InitializationGuard = () => {
  const initalTokens = loadTokensFromCookies();
  const { setTokens } = useAuthActions();
  const accessToken = useAccessToken();
  const refreshToken = useRefreshToken();

  useEffect(() => {
    if (!accessToken && !refreshToken) {
      setTokens(
        initalTokens?.accessToken || '',
        initalTokens?.refreshToken || ''
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Outlet />;
};

export default InitializationGuard;
